import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Client auth uses session_token httpOnly cookie (set by /api/auth/session)
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Admin auth uses admin_token httpOnly cookie (set by /api/admin/login).
// No more localStorage — relies on the cookie travelling with same-origin XHR.
export const adminApi = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Authenticated file download via fetch (preserves cookies + supports blob).
export const authedFetch = (path, options = {}) =>
  fetch(`${API}${path}`, { credentials: "include", ...options });
